<template>
  <div
    class="mb-10 flex h-max w-max flex-col flex-wrap items-start gap-5 text-wrap lg:h-[214px] lg:w-[90%]"
  >
    <button class="w-max" @click="goBack">← BACK</button>

    <span v-if="subTitle" class="text-xs">{{ subTitle }}</span>
  </div>
</template>

<script setup>
  defineProps(["subTitle", "goBack"]);
</script>
